import Logo from "../../src/assets/Logo.svg"
import { Link } from 'react-router-dom';
import ForgetPasswordForm from "../components/Auth/ForgetPasswordForm";
import AuthContainer from "../components/Shared/AuthContainer";
import { motion } from "framer-motion";
import { Helmet } from 'react-helmet';
const ForgetPassword = () => {
  return (
    <div className="min-h-screen  px-4 md:py-10 py-5 flex justify-between gap-16">
            <Helmet>
        <link rel="canonical" href="https://www.nilewisect.com/forget-password" />
      </Helmet>
    <motion.div initial={{ x: -60, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}  className="flex flex-col w-full lg:basis-[40%]">
        <Link to="/" className="flex items-center gap-1.5 md:justify-start justify-center md:border-b-0 border-b border-black/15 md:pb-0 pb-5">
        <img src={Logo} className="md:h-auto md:w-auto w-36 h-auto" />
        </Link>
        <ForgetPasswordForm/>
    </motion.div>
    <AuthContainer/>
</div>
)
}

export default ForgetPassword